import React, { useState } from 'react';
import { IoMdMenu } from 'react-icons/io';
// Images
import LogoWhite from '../../assets/images/logos/the-tavistock-inn-hotel-and-resturant.webp';
// Constants
import { CompanyName } from '../../utils/Constants';

function Navbar() {
  const [isPhoneNavOpen, setIsPhoneNavOpen] = useState(false);

  const navItems = [
    { path: '#menu', label: 'Menu' },
    { path: '#rooms', label: 'Rooms' },
    { path: '#poker', label: 'Poker' },
    { path: '#map', label: 'Contact' },
  ];

  const togglePhoneNav = () => {
    setIsPhoneNavOpen((prev) => !prev);
  };

  const handleNavClick = (path) => {
    const targetElement = document.querySelector(path);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      setIsPhoneNavOpen(false); // Close the mobile menu after navigating
    }
  };

  return (
    <nav
      role="navigation"
      aria-label="Main Navigation"
      className="relative bg-transparent"
    >
      <div className="grid grid-cols-reg px-4 py-4">
        <section>
          <a href="#home">
            <img
              src={LogoWhite}
              alt={`${CompanyName} business logo - White Logo`}
              className="w-10 h-10 lg:w-16 lg:h-16 cursor-pointer active:scale-95"
            />
          </a>
        </section>

        <section className="grid justify-end">
          {/* Mobile screen */}
          <button
            aria-label="Toggle navigation menu"
            onClick={togglePhoneNav}
            className="grid md:hidden w-fit h-fit items-center justify-center text-4xl text-colour2 cursor-pointer"
          >
            <IoMdMenu className="active:scale-90 duration-300" />
          </button>

          {/* Large screen */}
          <ul className="hidden md:grid grid-flow-col gap-6 items-center text-colour2 pr-4">
            {navItems.map(({ path, label }) => (
              <NavItem
                key={label}
                url={path}
                title={label}
                onClick={() => handleNavClick(path)}
              />
            ))}
          </ul>
        </section>
      </div>

      {/* Phone navbar */}
      <div
        className={`phone-nav absolute top-full left-0 w-full bg-main-background transition-transform duration-300 ${
          isPhoneNavOpen
            ? 'translate-y-0 opacity-100'
            : '-translate-y-full opacity-0'
        }`}
      >
        <ul className="grid gap-8 items-center justify-center text-center text-colour2 py-10">
          {navItems.map(({ path, label }) => (
            <NavItem
              key={label}
              url={path}
              title={label}
              onClick={() => handleNavClick(path)}
            />
          ))}
        </ul>
      </div>
    </nav>
  );
}

const NavItem = ({ url, title, onClick }) => {
  return (
    <li className="active:scale-90">
      <button
        aria-label={`${title} section navigation`}
        className="text-xl md:text-lg font-semibold font-poppins hover:brightness-125 duration-200 active:scale-75"
        onClick={onClick}
      >
        {title}
      </button>
    </li>
  );
};

export default Navbar;
